if (!customElements.get('shoppable-image')) {
  customElements.define(
    'shoppable-image',
    class ShoppableImage extends HTMLElement {
      constructor() {
        super();
        this.hotspots = this.querySelectorAll('.shoppable-image__hotspot');
        this.init();
      }

      init() {
        this.hotspots.forEach((hotspot) => {
          const pin = hotspot.querySelector('.shoppable-image__pin');
          const closeBtn = hotspot.querySelector('.shoppable-image__popover-close');

          if (pin) {
            // Desktop hover
            hotspot.addEventListener('mouseenter', () => {
              this.activateHotspot(hotspot);
            });

            hotspot.addEventListener('mouseleave', () => {
              this.deactivateHotspot(hotspot);
            });

            // Click / Touch toggle
            pin.addEventListener('click', (e) => {
              e.stopPropagation();
              const isActive = hotspot.classList.contains('shoppable-image__hotspot--active');
              this.deactivateAll();
              if (!isActive) {
                this.activateHotspot(hotspot);
              }
            });
          }

          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              this.deactivateHotspot(hotspot);
            });
          }
        });

        // Close on outside click
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            this.deactivateAll();
          }
        });

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.deactivateAll();
          }
        });
      }

      activateHotspot(hotspot) {
        this.deactivateAll();
        hotspot.classList.add('shoppable-image__hotspot--active');
        const pin = hotspot.querySelector('.shoppable-image__pin');
        const popover = hotspot.querySelector('.shoppable-image__popover');
        if (pin) pin.setAttribute('aria-expanded', 'true');
        if (popover) popover.setAttribute('aria-hidden', 'false');
      }

      deactivateHotspot(hotspot) {
        hotspot.classList.remove('shoppable-image__hotspot--active');
        const pin = hotspot.querySelector('.shoppable-image__pin');
        const popover = hotspot.querySelector('.shoppable-image__popover');
        if (pin) pin.setAttribute('aria-expanded', 'false');
        if (popover) popover.setAttribute('aria-hidden', 'true');
      }

      deactivateAll() {
        this.hotspots.forEach((hotspot) => this.deactivateHotspot(hotspot));
      }
    }
  );
}
